import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { BannerJsmPackagingUpdate } from './banner/index.tsx';

const BannerTransition = lazyAfterPaint<typeof BannerJsmPackagingUpdate>(() =>
	import(/* webpackChunkName: "async-banner-jsm-packaging-updates" */ './banner').then(
		(module) => module.BannerJsmPackagingUpdate,
	),
);

export const BannerJsmPackagingUpdateAsync = () => (
	<Placeholder name="async-banner-jsm-packaging-updates" fallback={null}>
		<BannerTransition />
	</Placeholder>
);
